import { AtlasV2PricePromotionPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2PricePromotionPageLayout';
import { AtlasV2PriceSummaryPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2PriceSummaryPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2PricePageLayout({ metricType }) {
  const salesPageLayout = {
    retailPrice: AtlasV2PriceSummaryPageLayout,
    promotions: AtlasV2PricePromotionPageLayout
  };

  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'pricePageLayout',
        CustomComponent: salesPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
